export const ORGANISATION_GROUP_NAMES_QUERY_KEY = 'getOrganisationGroupById';
